const categories = state => state.categories;
const interactCategories = state => state.interactCategories;
const charsMedia = state => state.charsMedia;

export {
  categories,
  interactCategories,
  charsMedia,
}